import { combineReducers } from 'redux';
import vehicles from './vehicles';

export default combineReducers({
    vehicles,
});
